import Helpers from "commons/helpers";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserAuthorization, IUserInfo } from "commons/interfaces";

export interface UserState {
    fetching?: boolean;
    accessible?: boolean;
    userInfo?: IUserInfo;
    errorMessage?: string;
    workingOrganization?: string;
    userAuthorization?: IUserAuthorization;
    organizationLogoUrl?: string
}

const initialState: UserState = {
    fetching: false,
    accessible: true,
    userInfo: undefined,
    errorMessage: undefined,
    userAuthorization: undefined,
    workingOrganization: undefined,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        fetchUser: (state) => {
            state.fetching = true;
        },

        fetchUserSuccess: (state, action: PayloadAction<UserState | undefined>) => {
            state.fetching = false;
            state.errorMessage = undefined;
            if (!Helpers.isNullOrEmpty(action.payload)) {
                state.userInfo = action.payload.userInfo;
                state.userAuthorization = action.payload.userAuthorization;
                state.workingOrganization = action.payload.workingOrganization;
            }
        },

        storeUserInfo: (state, action: PayloadAction<IUserInfo>) => {
            state.userInfo = action.payload;
        },

        fetchUserFailed: (state, action: PayloadAction<string>) => {
            state.fetching = false;
            state.errorMessage = action.payload;
        },

        resetUser: () => initialState,
    },
});

// Action creators are generated for each case reducer function
export const {
    resetUser,
    fetchUser,
    storeUserInfo,
    fetchUserFailed,
    fetchUserSuccess,
} = userSlice.actions;

export default userSlice.reducer;
